<template>
    <div>
        <v-chart ref="chart" :options="chartOptions"/>
    </div>
</template>

<script>
    import vChart from '@/components/v-chart';

    export default {
        name: 'metrics-sparkline',
        components: {vChart},
        props: {
            data: {
                type: Array,
                default: () => [],
            },
            color: {
                type: String,
            },
        },
        computed: {
            chartOptions() {
                return {
                    chart: {
                        backgroundColor: null,
                        borderWidth: 0,
                        type: 'areaspline',
                        margin: [0, 0, 0, 0],
                        spacing: [0, 0, 0, 0],
                        height: 50,
                        style: {
                            overflow: 'visible',
                        },
                        // small optimalization, saves 1-2 ms each sparkline
                        skipClone: true,
                        shadow: false,
                        plotBorderWidth: 0,
                        plotBorderColor: '#ffffff',
                    },
                    title: {
                        text: null,
                    },
                    legend: {
                        enabled: false,
                    },
                    tooltip: {
                        enabled: false,
                    },
                    xAxis: {
                        labels: {
                            enabled: false,
                        },
                        title: {
                            text: null,
                        },
                        startOnTick: false,
                        endOnTick: false,
                        tickPositions: [],
                        lineWidth: 0,
                        minorGridLineWidth: 0,
                        gridLineWidth: 0,
                        gridLineColor: 'transparent',
                    },
                    yAxis: {
                        endOnTick: false,
                        startOnTick: false,
                        labels: {
                            enabled: false,
                        },
                        title: {
                            text: null,
                        },
                        tickPositions: [0],
                        gridLineColor: 'transparent',
                    },
                    plotOptions: {
                        areaspline: {
                            lineWidth: 4,
                            lineColor: `rgba(${this.color},1)`,
                            animation: {
                                duration: 500,
                            },
                            marker: {
                                enabled: false,
                            },
                            enableMouseTracking: false,
                        },
                    },
                    series: [
                        {
                            data: this.data,
                            pointStart: 1,
                            fillColor: {
                                linearGradient: [0, 0, 0, 50],
                                stops: [
                                    [0, `rgba(${this.color},0.8)`],
                                    [1, 'rgba(255,255,255,0.2)'],
                                ],
                            },
                        },
                    ],
                };
            },
        },
        methods: {
            reflow() {
                this.$refs.chart.$emit('reflow');
            },
        },
        created() {
            this.$on('reflow', this.reflow);
        },
        beforeDestroy() {
            this.$off('reflow');
        },
    };
</script>
